import {
  Box,
  createStyles,
  makeStyles,
  TableCell,
  TableCellBaseProps,
  Theme,
  useTheme,
} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import VoxelTooltipShort from '../../../../../components/voxel/Tooltip/VoxelTooltipShort';
import { ContentActionGq } from '../../../../../graphql/projects/models/ContentActionGq';
import { ContentKeywordGq } from '../../../../../graphql/projects/models/ContentKeywordGq';
import TaskAction from '../ContentTaskTable/TaskAction';
import { getTaskUrl } from '../ContentTaskTable/TaskUrl';

export interface TableCellUrlIconProps {
  contentKeyword: ContentKeywordGq;
  clientUrl: string;
  component?: React.ElementType<TableCellBaseProps>;
}

const useClasses = makeStyles((theme: Theme) =>
  createStyles({
    cellOverflow: {
      boxSizing: 'border-box',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    createUrl: {
      color: theme.palette.grey[500],
    },
  })
);

const TableCellUrl: React.FC<TableCellUrlIconProps> = React.memo(
  ({ contentKeyword, clientUrl, component }) => {
    //Styling
    const theme = useTheme();
    const classes = useClasses(theme);

    return (
      <TableCell component={component}>
        <Box maxWidth={'300px'} display={'flex'} flexDirection={'row'} alignContent={'center'}>
          <Box pr={2}>
            <VoxelTooltipShort message={contentKeyword.taskAction}>
              <TaskAction action={contentKeyword.taskAction} table={true} size={'small'} />
            </VoxelTooltipShort>
          </Box>
          <Box
            className={clsx({
              [classes.cellOverflow]: true,
              [classes.createUrl]: contentKeyword.taskAction === ContentActionGq.CREATE,
            })}
          >
            {getTaskUrl(contentKeyword.taskUrl, clientUrl)}
          </Box>
        </Box>
      </TableCell>
    );
  }
);

export default TableCellUrl;
